'use strict';

/**
 * @ngdoc function
 * @name ribytRsvpApp.controller:TicketCtrl
 * @description
 * # TicketCtrl
 * Controller of the ribytRsvpApp
 */
angular.module( 'ribytRsvpApp' )
    .controller( 'TicketCtrl', ['$scope', '$rootScope', 'lodash', 'ENV', '$timeout', '$http', 'notificationService', '$sessionStorage', 'variableSubstitution', '$sce', function ( $scope, $rootScope, _, ENV, $timeout, $http, notificationService, $sessionStorage, $variableSubstitution, $sce ) {
        var invite = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );
        $rootScope.showICSButton = false;
        $rootScope.bannerImage = false;
        $rootScope.showPDFButton = true;
        $rootScope.isTicketPage = true;
        $rootScope.isLandingPage = false;
        $scope.showPastTickets = false;

        if (_.get( $sessionStorage, 'preview' )) {
            $rootScope.preview = true;
        }

        if (_.get( $rootScope, 'parameters.invite' )) {
            invite = $rootScope.decryptInvite( _.get( $rootScope, 'parameters.invite', null ) );
        }

        // prepare PDF url stuff
        var fileName = [
            _.get( invite, 'guestID.name.first' ),
            _.get( invite, 'guestID.name.last' ),
            _.get( invite, 'eventID.name' )
        ].join( '_' );

        $rootScope.hideTabs = true;

        // only go through if we have an invite
        if (invite && invite.byts.length > 0) {
            // remove byts that are not enabled
            _.remove( invite.byts, function eachByt ( n ) {
                // this would remove the byt if n.isAccepted === false or n.isEnabled === false - ns
                // to account for the guest declined hotel or air originally and then the host re-enables the byt, we needed to check for isAccepted=false and n.isEnabled=false to remove the byt
                // return (n.isEnabled === false) || (n.isAccepted === false && !n.isEnabled);
                return ( n.isEnabled === false || n.isAccepted === false || n.type !== 'Ticket' );
            } );
            invite.byts.sort( function ( item1, item2 ) {
                return moment.utc( item1.bytID.datetimeStart ).diff( moment.utc( item2.bytID.datetimeStart ) );
            } );

            $scope.inviteData = {
                'eventName': _.get( invite, 'eventID.name' ),
                'inviteType': _.get( invite, 'type' ),
                'guestID': _.get( invite, 'guestID' ),
                'ticketPageDetails': _.get( invite, 'experienceID.ticketPageDetails' )
            };
            $scope.ticketData = invite.byts;
            var pastTickets = [];
            var tickets = [];

            var currentDate =  moment.utc( moment().format( 'YYYY-MM-DDTHH:mm:ss' ) );

            invite.byts.map( function ( t ) {
                return { ticket: t, barcodes: t.bytDetails.barcode };
            } ).forEach( function ( t ) {
                var hidePastTicketsDate = moment.utc( t.ticket.bytID.datetimeStart ).add( invite.experienceID.ticketPageDetails.hidePastTicketsAfterMinutes, 'minutes' );

                t.barcodes.forEach( function ( b, index ) {
                    if ( invite.experienceID.ticketPageDetails.shouldHidePastTickets && currentDate.isAfter( hidePastTicketsDate ) ) {
                        pastTickets.push( { ticket: t.ticket, barcode: b, index: index + 1, total: t.barcodes.length } );
                    } else {
                        tickets.push( { ticket: t.ticket, barcode: b, index: index + 1, total: t.barcodes.length } );
                    }
                } );
            } );

            // Ticket Data for Print
            $scope.isPrintToggle = false;
            $scope.printTickets = tickets;

            $scope.tickets = tickets.slice( 0, 4 );
            $scope.pastTickets = pastTickets.slice( 0, 4 );
            $scope.pastTicketsTotal = pastTickets.length;

            $scope.invite = invite;

            $scope.ticketsPagination = function () {
                var start = $scope.tickets.length;
                if ( $scope.tickets.length >= tickets.length ) {
                    return;
                }
                $scope.tickets = $scope.tickets.concat( tickets.slice( start, start + 4 ) );
            };

            $scope.pastTicketsPagination = function () {
                var start = $scope.pastTickets.length;
                if ( $scope.pastTickets.length >= pastTickets.length ) {
                    return;
                }

                $scope.pastTickets = $scope.pastTickets.concat( pastTickets.slice( start, start + 4 ) );
            };

            $scope.showFinePrint = true;
            $scope.showHeaderImage = true;
            $scope.showHeaderText = true;
            $scope.showHeaderTitle = true;
            $scope.showImage1 = true;
            $scope.showImage1Caption = true;
            $scope.showImage2 = true;
            $scope.showImage2Caption = true;
            if ($scope.inviteData.ticketPageDetails && $scope.inviteData.ticketPageDetails.isHideField) {
                $scope.showFinePrint = $scope.inviteData.ticketPageDetails.isHideField.hasOwnProperty( 'finePrint' ) ? !$scope.inviteData.ticketPageDetails.isHideField.finePrint : true;
                $scope.showHeaderImage = $scope.inviteData.ticketPageDetails.isHideField.hasOwnProperty( 'headerImage' ) ? !$scope.inviteData.ticketPageDetails.isHideField.headerImage : true;
                $scope.showHeaderText = $scope.inviteData.ticketPageDetails.isHideField.hasOwnProperty( 'headerText' ) ? !$scope.inviteData.ticketPageDetails.isHideField.headerText : true;
                $scope.showHeaderTitle = $scope.inviteData.ticketPageDetails.isHideField.hasOwnProperty( 'headerTitle' ) ? !$scope.inviteData.ticketPageDetails.isHideField.headerTitle : true;
                $scope.showImage1 = $scope.inviteData.ticketPageDetails.isHideField.hasOwnProperty( 'image1' ) ? !$scope.inviteData.ticketPageDetails.isHideField.image1 : true;
                $scope.showImage1Caption = $scope.inviteData.ticketPageDetails.isHideField.hasOwnProperty( 'image1Caption' ) ? !$scope.inviteData.ticketPageDetails.isHideField.image1Caption : true;
                $scope.showImage2 = $scope.inviteData.ticketPageDetails.isHideField.hasOwnProperty( 'image2' ) ? !$scope.inviteData.ticketPageDetails.isHideField.image2 : true;
                $scope.showImage2Caption = $scope.inviteData.ticketPageDetails.isHideField.hasOwnProperty( 'image2Caption' ) ? !$scope.inviteData.ticketPageDetails.isHideField.image2Caption : true;
            }
            // talk to the api to get the PDF
            $rootScope.getPDF = function () {
                // $scope.isPrintToggle = true;
                if (!$rootScope.loadingPDF) {
                    // show a loading spinner
                    $rootScope.loadingPDF = true;

                    notificationService.notice( 'Please wait while we generate your PDF.' + '<br>' + '<br>' + 'PLEASE NOTE: If you have a popup blocker enabled in your web browser, your PDF will be saved to your computer. Otherwise, it will automatically open in your browser' );
                    var url = _.get( ENV, 'apiEndpoint', 'http://localhost:1338' ) + '/ribyt/rsvp/' + _.get( $rootScope, 'inviteHash' ) + '/tickets/pdf';
                    $http( {
                        'url': url,
                        'responseType': 'arraybuffer',
                        'method': 'GET'
                    } )
                        .then( function success ( response ) {
                            // hide the spinner
                            $rootScope.loadingPDF = false;

                            var file = new Blob( [response.data], {'type': 'application/pdf'} );
                            var fileURL = URL.createObjectURL( file );
                            var pdfFileName = _.get( invite, 'guestID.name.first' ) + ' ' + _.get( invite, 'guestID.name.last' ) + ' Ticket';

                            // Early Bail for IE 11, IE doesn't allow using a blob object directly as link href
                            // Instead it is necessary to use msSaveOrOpenBlob
                            if ( window.navigator.msSaveOrOpenBlob ) {
                                window.navigator.msSaveOrOpenBlob( file, pdfFileName + '.pdf' );
                            } else {
                                // Add a popup blocker detection
                                var isPopupBlockerEnabled = window.open( 'about:blank', '', 'width=1,height=1' );

                                setTimeout( function () {
                                    if ( isPopupBlockerEnabled && isPopupBlockerEnabled.innerHeight && isPopupBlockerEnabled.innerHeight > 0 ) {
                                        isPopupBlockerEnabled.close();
                                        window.open( fileURL );
                                    } else {
                                        var downloadDiv = document.createElement( 'a' );
                                        document.body.appendChild( downloadDiv );
                                        downloadDiv.style = 'display: none';
                                        downloadDiv.href = fileURL;
                                        downloadDiv.download = pdfFileName;
                                        downloadDiv.click();
                                        window.URL.revokeObjectURL( fileURL );

                                        // Double check if the popup blocker is closed
                                        if ( isPopupBlockerEnabled ) {
                                            isPopupBlockerEnabled.close();
                                        }
                                    }
                                }, 800 );
                            }
                        }, function error () {
                            $rootScope.loadingPDF = false;
                            notificationService.error( 'There was an error generating the PDF.' );
                        } );
                }
            };

            $scope.trustedHtml = function ( plainText ) {
                return $sce.trustAsHtml( $variableSubstitution.doSubstitutions( plainText ) );
            };

            $scope.image1Src = $rootScope.getImagePath( $scope.invite, 'experienceID.ticketPageDetails.image1FileID' );
            $scope.image2Src = $rootScope.getImagePath( $scope.invite, 'experienceID.ticketPageDetails.image2FileID' );
        }
    }] );
